import React, { Suspense } from "react";
import Loading from "react-loading";
import { Routes, Route } from "react-router-dom";
import Export from "../search/Export";
import SafetySearchForm from "../search/SafetySearchForm";

const NotAuthorized = React.lazy(() => import("../NotAuthorized"));
const NoMatch = React.lazy(() => import("../NoMatch"));
const LoginFailure = React.lazy(() => import("../LoginFailure"));
const Login = React.lazy(() => import("../Login"));
const SearchForm = React.lazy(() => import("../search/SearchForm"));
const SearchResults = React.lazy(() => import("../search/SearchResults"));
const ExportComplete = React.lazy(() => import("../search/ExportComplete"));

const AuthenticatedRoutes: React.FC = () => {
  return (
    <Suspense fallback={<Loading></Loading>}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/NotAuthorized" element={<NotAuthorized />} />
        <Route path="/LoginFailure" element={<LoginFailure />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/SafetySearch" element={<SafetySearchForm />} />

        <Route path="/SearchResults" element={<SearchResults />} />
        <Route path="/Search" element={<SearchForm />} />
        <Route path="/Export" element={<Export />} />

        <Route path="/ExportComplete" element={<ExportComplete />} />
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </Suspense>
  );
};

export default AuthenticatedRoutes;
